export const isTouchDevice = (() => {
    var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
    var mq = function(query) {
        if(!window.matchMedia) {
            return false;
        }
        return window.matchMedia(query).matches;
    }

    if (('ontouchstart' in window || navigator.maxTouchPoints) || window.DocumentTouch && document instanceof DocumentTouch) {
        return true;
    }

    // include the 'heartz' as a way to have a non matching MQ to help terminate the join
    // https://git.io/vznFH
    var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
    return mq(query);
})();
const USER_AGENT = navigator.userAgent.toLowerCase();


export const isIOS = /ipad|iphone|ipod/.test(USER_AGENT);
export const isIPHONE = /iphone/.test(USER_AGENT);
export const isIPAD = /ipad/.test(USER_AGENT);
export const isIPOD = /ipod/.test(USER_AGENT);
export const isAndroid = /android/.test(USER_AGENT);
export const isBlackBerry = /blackberry/.test(USER_AGENT);
export const isWebOS = /webos/.test(USER_AGENT);
export const isKindle = /silk|kindle/.test(USER_AGENT);
export const isTeamsAndroid = /teamsmobile-android/.test(USER_AGENT);
export const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(USER_AGENT);

// export const isTablet = /(tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(USER_AGENT);
// export const isMobile = isTablet || (/mobile/.test(USER_AGENT) || isIOS || isAndroid || isBlackBerry || isWebOS || isKindle || isIPAD || isMiPad);
export const isMobile = isTablet || (/mobile/.test(USER_AGENT) || isIOS || isAndroid || isBlackBerry || isWebOS || isKindle || isIPAD || isMiPad);
// export const isMobile = (isTablet || isTeamsAndroid) || (/mobile/.test(USER_AGENT) || isIOS || isAndroid || isBlackBerry || isWebOS || isKindle || isIPAD || isMiPad);
export const isDesktop = !isMobile && !isTablet && !isAndroid && !isIPHONE && !isIPAD && !isIPOD && !isKindle && !isWebOS;
export const isMiPad = /(MI(.*|\s*)PAD).*/i.test(USER_AGENT);
export const isXiaomi = !isMiPad && /MI(\s+|\d+?|HM|xiaomi).*/i.test(USER_AGENT);
export const isHuawei = /HUAWEI/.test(navigator.userAgent);

export const isMac = /macintosh|mac os x/i.test(navigator.userAgent);//Mac
export const isMacSsoNoIos = isMac && !isIOS; // mac端Ios走sso.foxitcloud.cn;IOS保持原逻辑
export const isWindows = /windows|win32/i.test(navigator.userAgent);//Windows
export const isTeamsApp = /Teams|TeamsMobile/i.test(USER_AGENT);
export const isFirefox = /firefox/.test(USER_AGENT);

export const DEVICE_DETACTION = {
    ios: isIOS,
    iphone: isIPHONE,
    ipad: isIPAD,
    ipod: isIPOD,
    android: isAndroid,
    blackberry: isBlackBerry,
    webos: isWebOS,
    kindle: isKindle,
    tablet: isTablet,
    mobile: isMobile,
    desktop: isDesktop,
    xiaomi: isXiaomi,
    huawei: isHuawei,
    touch: isTouchDevice,
    mac: isMac,
    windows: isWindows
};
